module.exports = __webpack_public_path__ + "img/ic-left-menu-dash-01.a3e6a8c0.svg";